module.exports = __webpack_public_path__ + "ec8a0f8ff19e615492764bc3c20b03c6.svg";